var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{class:[_vm.color, _vm.determinate ? 'determinate' : 'indeterminate', _vm.width]})])}
var staticRenderFns = []

export { render, staticRenderFns }